module.exports = __webpack_public_path__ + "static/img/machine1.b38fb031.png";